/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free investment calculators — SIP, lump-sum, fixed deposit and compound interest. Estimate returns in seconds. No signup.`)
};

const es_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de inversión gratuitas — SIP, suma única, depósito fijo e interés compuesto. Estima retornos en segundos. Sin registrarse.`)
};

const de_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Anlage-Rechner — SIP, Pauschalanlage, Festgeldanlage und Zinseszins. Schätzen Sie die Renditen in Sekunden. Keine Anmeldung erforderlich.`)
};

const nl_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis beleggingscalculators — SIP, eenmalige belegging, vaste storting en samengestelde rente. Schat rendement in seconden in. Geen registratie vereist.`)
};

const fr_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrices d'investissement gratuites — SIP, versement unique, dépôt fixe et intérêt composé. Estimez les rendements en secondes. Pas d'inscription.`)
};

const it_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatori di investimento gratuiti — SIP, investimento forfettario, deposito fisso e interesse composto. Stima i rendimenti in secondi. Nessuna registrazione.`)
};

const pt_br2_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de investimento gratuitas — SIP, investimento único, depósito fixo e juros compostos. Estime retornos em segundos. Sem necessidade de registro.`)
};

const pt_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de investimento gratuitas — SIP, montante único, depósito fixo e juro composto. Estime retornos em segundos. Sem registo.`)
};

const ja_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の投資計算機 — SIP、一括投資、定期預金、複利計算。数秒で返却額を推定。登録不要。`)
};

const zh_sip_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费投资计算器——SIP、一次性投资、定期存款和复利。快速估算收益。无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_tool_description", locale)
	if (locale === "en") return en_sip_tool_description(inputs)
	if (locale === "es") return es_sip_tool_description(inputs)
	if (locale === "de") return de_sip_tool_description(inputs)
	if (locale === "nl") return nl_sip_tool_description(inputs)
	if (locale === "fr") return fr_sip_tool_description(inputs)
	if (locale === "it") return it_sip_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_sip_tool_description(inputs)
	if (locale === "pt") return pt_sip_tool_description(inputs)
	if (locale === "ja") return ja_sip_tool_description(inputs)
	return zh_sip_tool_description(inputs)
};